import { render, staticRenderFns } from "./ProfileScoreView.vue?vue&type=template&id=78b8bb7c"
import script from "./ProfileScoreView.vue?vue&type=script&lang=js"
export * from "./ProfileScoreView.vue?vue&type=script&lang=js"
import style0 from "./ProfileScoreView.vue?vue&type=style&index=0&id=78b8bb7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports